// ================================================================================
// swiper.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {


	const recruitSlide = new Swiper('.js-recruit-slide', {
		loop: true,
		effect: 'fade',
		speed: 3000,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
	});

} );






